import { AttributeBaseType } from "./AttributeBaseType";
import { AttributeComponentType } from "./AttributeComponentType";
import { AttributeDescription } from "./AttributeDescription";
import { AttributeHeadline } from "./AttributeHeadline";
import { AttributeInfoText } from "./AttributeInfoText";
import { AttributePropertyText } from "./AttributePropertyText";
import { AttributeWrapper } from "./AttributeWrapper";
export const AttributeComponents = {
    // sub components
    [AttributeComponentType.AttributeHeadline]: AttributeHeadline,
    [AttributeComponentType.AttributeDescription]: AttributeDescription,
    [AttributeComponentType.AttributeInfoText]: AttributeInfoText,
    [AttributeComponentType.AttributePropertyText]: AttributePropertyText,
    // base type
    [AttributeBaseType.SingleOption]: AttributeWrapper,
    [AttributeBaseType.MultiOption]: AttributeWrapper,
    [AttributeBaseType.Static]: AttributeWrapper,
    [AttributeBaseType.Substructure]: AttributeWrapper,
    [AttributeBaseType.Editable]: AttributeWrapper,
    [AttributeBaseType.Boolean]: AttributeWrapper,
};
//# sourceMappingURL=AttributeComponents.js.map